import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import Rating from '@material-ui/lab/Rating';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import { orderStatus } from '../../../../helpers';

class TutorBookingItems extends Component {



    totalPrice = (price) => {
        const { config } = this.props.config;
        const commission_rate = config && config.commission_rate;
        price = price ? price : 0;
        const tax = parseFloat(price) * parseFloat(commission_rate) / 100;
        return (parseFloat(price) - parseFloat(tax)).toFixed(2);
    }

    render() {
        const { book } = this.props;
        return (
            <div className="post-box mb-4">
                <div className="row">
                    <div className="col-xl-4 col-md-12 col-12">
                        <div className="media">
                            <div className="image">
                                <img className="mr-4 img-circle" src={book.user.avatar} alt="pic" width="70" height="70" />
                            </div>
                            <div className="media-body">
                                <h5>{book.user.name}</h5>
                                {/* <div className="rating mb-2">
                                    <span className="star">
                                        {(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.rating_avg) &&
                                        <Rating name="size-medium" value={parseInt(book.userCatalogOrdersItems[0].user.rating_avg)} readOnly />}
                                    </span>
                                    <span> ({book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.rating_avg}) {book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.count_rating} Ratings</span>
                                </div> */}
                                <div className="rating mb-2">
                                    <span className="star">
                                        {(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.rating_avg) &&
                                            <Rating name="size-medium" value={parseInt(book.userCatalogOrdersItems[0].user.rating_avg)} readOnly />}
                                    </span>
                                    <span> ({book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.rating_avg}) {book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.count_rating} Ratings</span>
                                </div>
                                <div className="location">
                                    <i className="fas fa-map-marker-alt"></i> {book.user && book.user.countryCode && book.user.countryCode.name}
                                </div> 
                            </div> 
                        </div>       
                    </div>
                    <div className="col-xl-3 col-md-7 col-12">
                        <div className="inform mt-4">
                            <div className="d-flex">
                                <label>Date :</label>
                                <div className="date">
                                    {moment(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].start_time * 1000).format('MM/DD/YYYY')}<br/> {moment(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].start_time * 1000).format('LT')} - {moment(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].start_time * 1000).add(60, 'minutes').format('LT')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2 col-md-5 col-12">
                        <div className="inform mt-4">
                            <div className="d-flex">
                                <label>Cost :</label>
                                <div className="date">  
                                    ${this.totalPrice(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].price)}
                                </div>
                            </div>
                        </div>
                        <div className="inform">
                            <div className="d-flex">
                                <label>Duration :</label>
                                <div className="date">  
                                    60 min
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-12 col-12 d-flex flex-md-row flex-column justify-content-between">
                        <div className="sub mt-xl-4 mt-lg-0 mt-4">
                            {}
                            {/* <button className="btn btn-light">{book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].catalog.title}</button> */}
                            {(book.is_dispute === 1) ? <span className={`badge badge-danger`}>Dispute</span> : <span className={`badge badge-${orderStatus.status(book).cls}`}>{orderStatus.status(book).title}</span> }
                        </div>
                        <div className="view mt-xl-4 mt-lg-0 mt-4">
                            <Link to={`/tutor/booking/${book.id}`}>View Details</Link>
                        </div>
                    </div>     
                </div>
            </div>
        );
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const configSelector = createSelector(
    state => state.config,
    config => config
);

const mapStateToProps = createSelector(
    processSelector,
    configSelector,
    (process, config) => ({
        process, config
    })
);

export default connect(mapStateToProps)(TutorBookingItems);